import { TicketStatusTypes, TicketUrgencyTypes } from './custom.ticket.item';

export class CustomTicketWidgetItem {

    TicketID: number;
    TicketNumber: string;
    AdminID: number;
    AdminName: string;
    MemberID: number;
    MemberName: string;
    IsInternal: boolean;
    DueDate: Date;
    DateTimeCreated: Date;
    FromEmail: string;
    Subject: string;
    Body: string;
    Status: TicketStatusTypes;
    Urgency: TicketUrgencyTypes;

    public static FixDates(item: CustomTicketWidgetItem) {

        if (item.DueDate != undefined && item.DueDate != null)
            item.DueDate = new Date(item.DueDate);

        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }
}

export class CustomTicketWidgetItemArray extends Array<CustomTicketWidgetItem> {

    constructor(...items: CustomTicketWidgetItem[]) {
        super(...items);
        Object.setPrototypeOf(this, CustomTicketWidgetItemArray.prototype);
    }

    public static FixDates(items: CustomTicketWidgetItemArray) {
        items.forEach(x => CustomTicketWidgetItem.FixDates(x));
    }

}
